import { Link, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '@/store/useAuth';
import { redirectToPanel, shouldSkipPanelRedirect } from '@/utils/panelRedirect';
import { Button } from '@/components/ui/button';

export default function ProtectedRoute({ children, requires }) {
  const isAuthenticated = useAuth((s) => s.isAuthenticated);
  const bootstrapping = useAuth((s) => s.bootstrapping);
  const features = useAuth((s) => s.features);
  const location = useLocation();

  const skipPanel = shouldSkipPanelRedirect(location.pathname);

  useEffect(() => {
    if (!bootstrapping && isAuthenticated && !skipPanel) {
      redirectToPanel();
    }
  }, [bootstrapping, isAuthenticated, skipPanel]);

  if (bootstrapping) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-blue-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (requires) {
    const required = Array.isArray(requires) ? requires : [requires];
    const hasAccess = required.every((key) => features.includes(key));
    if (!hasAccess) {
      return (
        <div className="flex min-h-[50vh] items-center justify-center px-4">
          <div className="max-w-md text-center">
            <h1 className="font-display text-2xl font-bold text-slate-900">Premium required</h1>
            <p className="mt-2 text-slate-600">
              This feature needs an active premium plan. Upgrade your subscription to continue.
            </p>
            <Button asChild className="mt-6 rounded-xl">
              <Link to="/dashboard/billing">View plans</Link>
            </Button>
          </div>
        </div>
      );
    }
  }

  return children;
}
